
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fermer le menu mobile lors du changement de page
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/prestations', label: 'Nos Prestations' },
    { path: '/confiance', label: 'Pourquoi Nous ?' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-xl' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16 sm:h-20 md:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer transform hover:scale-105 transition-transform duration-300">
            <img 
              src="https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/58da3f7e4785850c57041e6c71714363.png" 
              alt="PRT Proprete" 
              className="h-12 sm:h-16 md:h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`whitespace-nowrap text-sm xl:text-base font-semibold transition-all duration-200 cursor-pointer relative group ${
                  location.pathname === link.path
                    ? 'text-[#E63946]'
                    : isScrolled ? 'text-gray-800 hover:text-[#E63946]' : 'text-white hover:text-[#00B4D8]'
                }`}
              >
                {link.label}
                <span className={`absolute bottom-0 left-0 w-0 h-0.5 bg-[#E63946] transition-all duration-300 group-hover:w-full ${
                  location.pathname === link.path ? 'w-full' : ''
                }`}></span>
              </Link>
            ))}
            <a
              href="tel:0776969414"
              className="whitespace-nowrap px-6 py-2.5 bg-gradient-to-r from-[#E63946] to-[#FF6B6B] text-white rounded-full font-bold hover:shadow-lg hover:shadow-[#E63946]/50 transition-all duration-300 cursor-pointer transform hover:scale-105 text-sm"
            >
              <i className="ri-phone-line mr-2"></i>
              Appeler
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-3 cursor-pointer ${isScrolled ? 'text-gray-800' : 'text-white'}`}
            aria-label="Menu"
          >
            <i className={`text-3xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden transition-all duration-300 overflow-hidden ${
        isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
      }`}>
        <div className="bg-white shadow-xl">
          <div className="px-4 py-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`whitespace-nowrap block text-lg font-semibold py-3 px-4 rounded-xl transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#E63946] bg-[#E63946]/10'
                    : 'text-gray-800 hover:text-[#E63946] hover:bg-gray-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:0776969414"
              className="whitespace-nowrap block text-center px-8 py-4 bg-gradient-to-r from-[#E63946] to-[#FF6B6B] text-white rounded-full font-bold hover:shadow-lg transition-all duration-300 cursor-pointer mt-4 text-lg"
            >
              <i className="ri-phone-line mr-2"></i>
              07.76.96.94.14
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
